import { ReadiedRoute, Redirect } from "@itandi/tools/next";
import { Page as Component } from "~/components/specifics/deals/[id]/Page";

export function Page() {
	return (
		<ReadiedRoute fallback={<Redirect url="/" />}>
			<Component />
		</ReadiedRoute>
	);
}
